/**
* AJAX Load (Lazy Load) events
*/


(function ($) {

	var ajaxLock = false;

	$('.load-more-controls .load-more-button').click(function (e) {
		e.preventDefault();
		var nonce, type, taxonomy, taxonomyId, totalPosts, perpage;

		nonce = $(this).data('nonce');
		type = $(this).data('type');
		taxonomy = $(this).data('taxonomy');
		taxonomyId = $(this).data('taxonomy-id');
		taxName = $(this).data('tax-name');
		totalPosts = parseInt($(this).data('total-results'));
		perpage = $(e.target).data('perpage');

		ajaxNextResults(nonce, type, taxonomy, taxName, taxonomyId, totalPosts, perpage);
	});

	function ajaxNextResults(nonce, type, taxonomy, taxName, taxonomyId, totalPosts, perpage) {
		var postOffset, action;
		ajaxLock = true;

		if ('taxonomy' == type) {
			action = 'load_more_in_category';
			postOffset = $('.category-news-article').length;
		}

		if ('departments' == type) {
			action = 'load_more_departments';
			postOffset = $(`#${taxonomy} .col-md-3`).length;
		}

		if ('news' == type) {
			action = 'load_more_news';
			postOffset = $('.news-article').length;
		}

		if ('estates' == type) {
			action = 'load_more_estates';
			postOffset = $('.estate-article').length;
		}

		if ('projects' == type) {
			action = 'load_more_projects';
			postOffset = $('.project-article').length;
		}


		if ('votaxonomy' == type) {
			action = 'load_more_estate_tax';
			postOffset = $('.category-estate-article').length;
		}

		if ('premises' == type) {
			action = 'load_more_premises';
			postOffset = $('.premises-article').length;
		}

		if ('premtax' == type) {
			action = 'load_more_premises_tax';
			postOffset = $('.category-premises-article').length;
		}

		if ('notiser' == type) {
			action = 'load_more_notiser';
			postOffset = $('.notis-article').length;
		}

		if ('notiser_tax' == type) {
			action = 'load_more_notiser_tax';
			postOffset = $('.category-notis-article').length;
		}
		$.ajax({
			method: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: action,
				nonce: nonce,
				taxonomy: taxonomy,
				taxonomyId: taxonomyId,
				taxName: taxName,
				perpage: perpage,
				offset: postOffset,
				totalPosts: totalPosts,
			},
			dataType: 'json',
		})
			.done(function (response) {

				if ('taxonomy' == response.type) {
					$(response.content).insertAfter('.category-news-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.category-news-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('departments' == response.type) {
					$(response.content).insertAfter(`section#${response.slug} .col-md-3:last`);

					// Hide button if all posts have been rendered
					if ((totalPosts - $(`section#${response.slug} .col-md-3`).length) <= 0) {
						$(`section#${response.slug} .load-more-button`).hide();
					}
				}

				if ('news' == response.type) {
					$(response.content).insertAfter('.news-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.news-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('estates' == response.type) {
					$(response.content).insertAfter('.estate-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.estate-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('projects' == response.type) {
					$(response.content).insertAfter('.project-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.project-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('votaxonomy' == response.type) {
					$(response.content).insertAfter('.category-estate-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.category-estate-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('premises' == response.type) {
					$(response.content).insertAfter('.premises-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.premises-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('premtax' == response.type) {
					$(response.content).insertAfter('.category-premises-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.category-premises-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('notiser' == response.type) {
					$(response.content).insertAfter('.notis-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.notis-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				if ('notiser_tax' == response.type) {
					$(response.content).insertAfter('.category-notis-article:last');

					// Hide button if all posts have been rendered
					if ((totalPosts - $('.category-notis-article').length) <= 0) {
						$('.load-more-button').hide();
					}
				}

				ajaxLock = false;
				console.log('Success');
				console.log(response);


			})
			.fail(function (jqXHR, textStatus, errorThrown) {
				ajaxLock = false;

				console.log(XMLHttpRequest);
				console.log(textStatus);
				console.log(errorThrown);

				console.log('Failed');
			});
	}

})(jQuery)
